import { swap2MinMax } from "./swap-2-min-max";

export const clamp = (value: number, min: number, max: number): number => {
  const [minValue, maxValue] = swap2MinMax(min, max);
  return Math.min(Math.max(value, minValue), maxValue);
};
